import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '100%',
    flexDirection: 'column',
    padding: theme.spacing(5, 2),
  },
  welcomeText: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(38),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(30),
    },
  },
  boxButtonsSocial: {
    gap: '20px',
  },
  boxLoginMicrosoft: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
  textLoginMicrosoft: {
    textAlign: 'center',
    fontWeight: 600,
  },
}))

export default styles
